import { render, staticRenderFns } from "./WolihubInicio.vue?vue&type=template&id=08981049&scoped=true"
import script from "./WolihubInicio.vue?vue&type=script&lang=js"
export * from "./WolihubInicio.vue?vue&type=script&lang=js"
import style0 from "./WolihubInicio.vue?vue&type=style&index=0&id=08981049&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08981049",
  null
  
)

export default component.exports